import { LeaseRepaymentTable } from './LeaseRepaymentTable'

export default LeaseRepaymentTable
